import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  filter,
  take,
  switchMap,
  catchError,
  throwError,
  from,
} from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(public authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/public/')) {
      return next.handle(req);
    }
    return from(this.authService.getValidToken()).pipe(
      switchMap(token => {
        const authReq = token
          ? req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            }
          })
          : req;
        return next.handle(authReq);
      }),
      catchError((err: any) => {
        // if (err.status === 401 && !req.url.includes('refresh')) {
        //   return this.handle401Error(req, next);
        // }
        return throwError(() => err);
      })
    );
  }
}
